import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'
import useUpdateMode from '../../hooks/useUpdateMode'
import { saveAnswer } from '../../utils/onboardingStorage'

const QUESTION_KEY = 'caution_level'

export default function CautionLevelPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const { isUpdate, postToReactNative } = useUpdateMode()

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const formData = new FormData(event.currentTarget)
    const formAnswer = formData.get('answer') as string

    const answer = {
      question_key: QUESTION_KEY,
      question: 'How cautious should we be when we discover something unusual?',
      answer_key: formAnswer.toLowerCase(),
      answer: formAnswer,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(formData, { method: 'post' })
    }
  }

  useEffect(() => {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({ type: 'REQUEST_ATT' }),
      )
    }
  }, [])

  return (
    <QuestionPage
      heading={t('pages.onboarding.cautionLevel.heading')}
      buttons={[
        {
          text: `🔴 ${t('pages.onboarding.cautionLevel.options.highAlert')}`,
          value: 'highAlert',
        },
        {
          text: `🟡 ${t('pages.onboarding.cautionLevel.options.nudgeNowAndThen')}`,
          value: 'nudgeNowAndThen',
        },
        {
          text: `⚪ ${t('pages.onboarding.cautionLevel.options.barelyAnyWarnings')}`,
          value: 'barelyAnyWarnings',
        },
        {
          text: `🔘 ${t('pages.onboarding.cautionLevel.options.noneAtAll')}`,
          value: 'noneAtAll',
        },
      ]}
      onSubmit={onSubmit}
      headingSize="text-3xl"
      buttonTextSize="text-base"
      buttonBgColor="bg-white"
    />
  )
}
